import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import User from '_class/User';
import api from 'lib/api';
import { addError } from 'actions';
import { getNotifications, getUserNotificationSettings } from 'actions/notifications';
import { setPageTitle, setPageActions } from 'actions/header';
import Modal from 'containers/Modals/Modal';
import FromNow from 'components/Presentation/Date/FromNow';
import Alert from 'components/Presentation/Notifications/Alert';
import { getActiveLanguage, translate, Skeleton } from '@haldor/ui';
import NotificationOptionForm from 'containers/Forms/NotificationOptionForm';

var Notifications = /*#__PURE__*/function (_Component) {
  _inherits(Notifications, _Component);

  var _super = _createSuper(Notifications);

  function Notifications(props) {
    var _this;

    _classCallCheck(this, Notifications);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
      _this.props.setPageTitle(_this.props.translate('notifications'));
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var lang;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.props.languages != null)) {
                _context.next = 26;
                break;
              }

              _this.setState({
                loading: true
              });

              lang = getActiveLanguage();

              if (!(lang == 'sv-se')) {
                _context.next = 8;
                break;
              }

              _context.next = 6;
              return _this.props.getNotifications("sv-SE");

            case 6:
              _context.next = 25;
              break;

            case 8:
              if (!(lang == 'da-dk')) {
                _context.next = 13;
                break;
              }

              _context.next = 11;
              return _this.props.getNotifications("da-DK");

            case 11:
              _context.next = 25;
              break;

            case 13:
              if (!(lang == 'nb-no')) {
                _context.next = 18;
                break;
              }

              _context.next = 16;
              return _this.props.getNotifications("nb-no");

            case 16:
              _context.next = 25;
              break;

            case 18:
              if (!(lang == 'uk')) {
                _context.next = 23;
                break;
              }

              _context.next = 21;
              return _this.props.getNotifications("uk");

            case 21:
              _context.next = 25;
              break;

            case 23:
              _context.next = 25;
              return _this.props.getNotifications("en-US");

            case 25:
              _this.setState({
                loading: false
              });

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(nextProps) {
        var lang;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(nextProps.languages != null)) {
                  _context2.next = 27;
                  break;
                }

                if (!(nextProps.notifications == null && nextProps.notifications.length < 1)) {
                  _context2.next = 27;
                  break;
                }

                _this.setState({
                  loading: true
                });

                lang = getActiveLanguage();

                if (!(lang == 'sv-se')) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 7;
                return _this.props.getNotifications("sv-SE");

              case 7:
                _context2.next = 26;
                break;

              case 9:
                if (!(lang == 'da-dk')) {
                  _context2.next = 14;
                  break;
                }

                _context2.next = 12;
                return _this.props.getNotifications("da-DK");

              case 12:
                _context2.next = 26;
                break;

              case 14:
                if (!(lang == 'nb-no')) {
                  _context2.next = 19;
                  break;
                }

                _context2.next = 17;
                return _this.props.getNotifications("nb-no");

              case 17:
                _context2.next = 26;
                break;

              case 19:
                if (!(lang == 'uk')) {
                  _context2.next = 24;
                  break;
                }

                _context2.next = 22;
                return _this.props.getNotifications("uk");

              case 22:
                _context2.next = 26;
                break;

              case 24:
                _context2.next = 26;
                return _this.props.getNotifications("en-US");

              case 26:
                _this.setState({
                  loading: false
                });

              case 27:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "onOptionsSubmit", function (values) {
      return new Promise(function (resolve) {
        var translate = _this.props.translate;
        api.post('notifications/userNotificationSettings', values).then(function () {
          _this.props.getUserNotificationSettings().then(function () {
            resolve(1);

            _this.props.addError(translate('changes-saved'), 'info');
          });
        })["catch"](function () {
          _this.props.addError(translate('Something went wrong while saving the options'), 'error');

          _this.setState({
            isSending: false
          });

          resolve(1);
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleOptionModal", function () {
      _this.setState({
        optionsModalVisible: !_this.state.optionsModalVisible
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeOptionsModal", function () {
      _this.setState({
        optionsModalVisible: false
      });
    });

    _this.state = {
      loading: false,
      optionsModalVisible: false
    };
    return _this;
  }

  _createClass(Notifications, [{
    key: "render",
    value: function render() {
      var notifications = this.props.notifications;
      return /*#__PURE__*/React.createElement("div", {
        className: "section latest",
        style: {
          margin: 0,
          padding: 0,
          border: 0
        }
      }, this.state.loading ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Alert, {
        type: "news"
      }, /*#__PURE__*/React.createElement(Skeleton, null))) : notifications != null && notifications.length == 0 ? /*#__PURE__*/React.createElement("div", {
        className: "color--meta text--center weight--bold"
      }, this.props.translate('no-new-notifications')) : null, notifications != null && notifications.length > 0 ? /*#__PURE__*/React.createElement("div", null, notifications.map(function (notification, i) {
        if (notification.referenceUrl !== null) {
          return /*#__PURE__*/React.createElement("a", {
            href: notification.referenceUrl,
            key: i
          }, /*#__PURE__*/React.createElement(Alert, {
            id: i,
            type: "news",
            key: i
          }, /*#__PURE__*/React.createElement("div", {
            className: "subtitle"
          }, /*#__PURE__*/React.createElement(FromNow, {
            utc: true
          }, notification.created)), notification.notificationText));
        }

        return /*#__PURE__*/React.createElement(Alert, {
          id: i,
          type: "news",
          key: i
        }, /*#__PURE__*/React.createElement("div", {
          className: "subtitle"
        }, /*#__PURE__*/React.createElement(FromNow, {
          utc: true
        }, notification.created)), notification.notificationText);
      })) : null);
    }
  }]);

  return Notifications;
}(Component);

function mapStateToProps(state) {
  var notifications = [];

  if (state.Notifications != null) {
    if (state.Notifications.notifications != null) {
      state.Notifications.notifications.forEach(function (notCol) {
        notifications = notifications.concat(notCol.notifications);
      });
      notifications = notifications.sort(function (a, b) {
        return b.id - a.id;
      });
    }
  }

  return {
    notifications: notifications,
    translate: translate(state.Languages.translations),
    languages: state.Languages.languages,
    currentUser: state.user.currentUser,
    userNotificationSettings: state.Notifications.userNotificationSettings
  };
}

export default connect(mapStateToProps, {
  addError: addError,
  getNotifications: getNotifications,
  setPageTitle: setPageTitle,
  setPageActions: setPageActions,
  getUserNotificationSettings: getUserNotificationSettings
})(Notifications);